/**
 * This enum type specifies the possible settings for placeholder text formatting.
 */
export enum PlaceholderTextFormat {
    /** Placeholder label and value text formatting are mutable */
    ALL = "all",

    /** Placeholder label text formatting is mutable */
    LABEL = "label",

    /** Placeholder value text formatting is mutable */
    VALUE = "value",
}
